module.exports = __webpack_public_path__ + "static/media/Excel.ffc38b84.svg";